/* PDI Costruttore Kit Premium — JS v4.2 (Sync Edit Tracker) */

window.initPdiKitBuilder = function() {
  
  function triggerHaptic() {
    if (navigator.vibrate) { navigator.vibrate(40); }
  }

  const DOM = {
    configData: document.getElementById('pdiKitConfig'),
    builderContainer: document.getElementById('pdiBuilderContainer'),
    addRowBtn: document.getElementById('pdiAddRowBtn'),
    trackerInput: document.getElementById('pdiTotalTrackerInput'),
    trackerFill: document.getElementById('pdiTrackerFill'),
    trackerWrap: document.getElementById('pdiGlobalTrackerWrap'),
    form: document.getElementById('pdi-quote-form'),
    submitBtn: document.getElementById('pdiSubmitBtn'),
    errorBox: document.getElementById('pdiSubmitError'),
    hiddenBody: document.getElementById('pdiHiddenBody'),
    userNotes: document.getElementById('pdiUserNotes')
  };

  if (!DOM.configData || !DOM.builderContainer) return;

  DOM.builderContainer.innerHTML = '';

  let config = {};
  try {
    config = JSON.parse(DOM.configData.textContent);
  } catch(e) {
    console.error("Errore lettura configurazione JSON:", e);
    return;
  }

  const minQty = config.minQty || 1;
  let rowIdCounter = 0;

  function getTotalQuantity() {
    let total = 0;
    if (DOM.builderContainer) {
      document.querySelectorAll('.pdi-kit-row-qinput').forEach(inp => {
        total += parseInt(inp.value, 10) || 0;
      });
    }
    return total;
  }

  function syncTotals() {
    let currentTotal = getTotalQuantity();
    
    if (DOM.trackerInput) DOM.trackerInput.value = currentTotal;

    if (DOM.trackerFill && DOM.trackerWrap) {
      let percentage = (currentTotal / minQty) * 100;
      if (percentage > 100) percentage = 100;
      DOM.trackerFill.style.width = percentage + '%';
      
      if (currentTotal >= minQty) {
        DOM.trackerWrap.classList.add('is-success');
      } else {
        DOM.trackerWrap.classList.remove('is-success');
      }
    }

    if (DOM.submitBtn) {
      if (currentTotal >= minQty) {
        DOM.submitBtn.disabled = false;
        DOM.submitBtn.textContent = 'Richiedi Preventivo Ora ➔';
        if (DOM.errorBox) DOM.errorBox.style.display = 'none';
      } else {
        DOM.submitBtn.disabled = true;
        DOM.submitBtn.textContent = `Mancano ${minQty - currentTotal} Kit per inviare`;
      }
    }
  }

  // --- LOGICA MODIFICA GLOBALE DA TRACKER ---
  function applyDeltaToFirstRow(delta) {
    if (delta === 0) return;
    const firstRowInput = document.querySelector('.pdi-kit-row-qinput');
    if (firstRowInput) {
      let currentVal = parseInt(firstRowInput.value, 10);
      let newVal = currentVal + delta;
      if (newVal < 0) newVal = 0;
      firstRowInput.value = newVal;
      syncTotals();
    }
  }

  const globalPlus = document.getElementById('globalPlusBtn');
  const globalMinus = document.getElementById('globalMinusBtn');

  if (globalPlus && DOM.trackerInput) {
    globalPlus.addEventListener('click', () => {
      triggerHaptic();
      applyDeltaToFirstRow(1);
    });
  }

  if (globalMinus && DOM.trackerInput) {
    globalMinus.addEventListener('click', () => {
      triggerHaptic();
      applyDeltaToFirstRow(-1);
    });
  }

  if (DOM.trackerInput) {
    DOM.trackerInput.addEventListener('change', () => {
      let newTotal = parseInt(DOM.trackerInput.value, 10);
      if (isNaN(newTotal) || newTotal < 0) newTotal = 0;
      
      let currentTotal = getTotalQuantity();
      let delta = newTotal - currentTotal;
      applyDeltaToFirstRow(delta);
    });
  }

  // --- CREAZIONE RIGHE ---
  function createRow(initialQty = 1) {
    if (!DOM.builderContainer || !config.items || config.items.length === 0) return null;
    
    rowIdCounter++;
    const row = document.createElement('div');
    row.className = 'pdi-kit-row';
    row.dataset.rowId = rowIdCounter;

    let html = `
      <div class="pdi-kit-row-header">
        <span class="pdi-kit-row-badge">Combinazione ${rowIdCounter}</span>
        <button type="button" class="pdi-kit-row-del" title="Rimuovi">✕ Rimuovi</button>
      </div>
      <div class="pdi-kit-items-wrap">
    `;

    config.items.forEach(capo => {
      html += `
        <div class="pdi-kit-item-block" data-item-name="${capo.title}">
          <div class="pdi-kit-item-name">${capo.title}</div>
      `;

      if (capo.visuals && capo.visuals.length > 0) {
        html += `<div class="pdi-kit-vetrina-notice">💡 Immagini Vetrina. Seleziona il colore nel menu a tendina.</div>`;
        html += `<div class="pdi-kit-swatch-display">`;
        capo.visuals.forEach(imgUrl => {
          if (imgUrl && imgUrl !== "") {
            html += `<img src="${imgUrl}" class="pdi-kit-swatch-img" style="background-color: ${capo.swatchBg};" loading="lazy">`;
          }
        });
        html += `</div>`;
      }

      html += `<div class="pdi-kit-dropdowns">`;

      if (capo.colors && capo.colors.length > 0) {
        html += `
          <div class="pdi-kit-opt-group">
            <label>Colore</label>
            <select class="pdi-kit-select pdi-kit-color-select">
              <option value="" selected disabled hidden>Seleziona colore</option>
              ${capo.colors.map(c => `<option value="${c}">${c}</option>`).join('')}
            </select>
          </div>
        `;
      }

      if (capo.sizes && capo.sizes.length > 0) {
        html += `
          <div class="pdi-kit-opt-group">
            <label>Taglia</label>
            <select class="pdi-kit-select pdi-kit-size-select">
              <option value="" selected disabled hidden>Seleziona taglia</option>
              ${capo.sizes.map(s => `<option value="${s}">${s}</option>`).join('')}
            </select>
          </div>
        `;
      }

      html += `</div></div>`;
    });

    html += `
      </div>
      <div class="pdi-kit-row-qty-wrap">
        <span class="pdi-kit-row-qty-label">Quantità Kit per questa combo:</span>
        <div class="pdi-kit-row-qty">
          <button type="button" class="pdi-kit-row-qbtn minus">-</button>
          <input type="number" class="pdi-kit-row-qinput" value="${initialQty}" min="0" readonly>
          <button type="button" class="pdi-kit-row-qbtn plus">+</button>
        </div>
      </div>
    `;

    row.innerHTML = html;
    DOM.builderContainer.appendChild(row);

    const qtyInp = row.querySelector('.pdi-kit-row-qinput');
    row.querySelector('.minus').addEventListener('click', () => {
      triggerHaptic();
      let v = parseInt(qtyInp.value, 10) - 1;
      if (v >= 0) {
        qtyInp.value = v;
        syncTotals();
      }
    });

    row.querySelector('.plus').addEventListener('click', () => {
      triggerHaptic();
      qtyInp.value = parseInt(qtyInp.value, 10) + 1;
      syncTotals();
    });

    row.querySelector('.pdi-kit-row-del').addEventListener('click', () => {
      if (document.querySelectorAll('.pdi-kit-row').length > 1) {
        triggerHaptic();
        row.remove();
        updateRowUIs();
        syncTotals();
      }
    });

    updateRowUIs();
    return row;
  }

  function updateRowUIs() {
    const rows = document.querySelectorAll('.pdi-kit-row');
    rows.forEach((r, index) => {
      r.querySelector('.pdi-kit-row-badge').textContent = `Combinazione ${index + 1}`;
      const btn = r.querySelector('.pdi-kit-row-del');
      if (rows.length === 1) btn.style.display = 'none';
      else btn.style.display = 'inline-block';
    });
  }

  if (config.items && config.items.length > 0) {
    createRow(minQty);
    syncTotals();
  }

  if (DOM.addRowBtn) {
    const newBtn = DOM.addRowBtn.cloneNode(true);
    DOM.addRowBtn.parentNode.replaceChild(newBtn, DOM.addRowBtn);
    newBtn.addEventListener('click', () => {
      triggerHaptic();
      createRow(1);
      syncTotals();
    });
  }

  if (DOM.form) {
    DOM.form.addEventListener('submit', (e) => {
      let currentTotal = getTotalQuantity();
      
      if (currentTotal < minQty) {
        e.preventDefault();
        if (DOM.errorBox) DOM.errorBox.style.display = 'block';
        return;
      }

      let messageBody = "=== DETTAGLIO CONFIGURAZIONE KIT ===\n\n";
      
      document.querySelectorAll('.pdi-kit-row').forEach((row, index) => {
        let qty = parseInt(row.querySelector('.pdi-kit-row-qinput').value, 10);
        
        if (qty > 0) {
          messageBody += `[ COMBINAZIONE ${index + 1} ] ---> QUANTITÀ: ${qty} KIT\n`;
          
          row.querySelectorAll('.pdi-kit-item-block').forEach(itemBlock => {
            let itemName = itemBlock.dataset.itemName;
            let color = itemBlock.querySelector('.pdi-kit-color-select')?.value || 'NON SELEZIONATO';
            let size = itemBlock.querySelector('.pdi-kit-size-select')?.value || 'NON SELEZIONATO';
            
            messageBody += `- ${itemName}: Colore ${color} | Taglia ${size}\n`;
          });
          messageBody += `\n`;
        }
      });

      messageBody += `----------------------------------------------\n`;
      messageBody += `TOTALE KIT RICHIESTI: ${currentTotal}\n`;
      messageBody += `----------------------------------------------\n\n`;

      if (DOM.userNotes && DOM.userNotes.value.trim() !== '') {
        messageBody += `=== NOTE E ISTRUZIONI DEL CLIENTE ===\n`;
        messageBody += DOM.userNotes.value.trim() + `\n\n`;
      }

      if (DOM.hiddenBody) {
        DOM.hiddenBody.value = messageBody;
      }

      if (DOM.submitBtn) {
        DOM.submitBtn.textContent = 'Invio in corso... ⏳';
        DOM.submitBtn.style.opacity = '0.7';
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', window.initPdiKitBuilder);
document.addEventListener('shopify:section:load', window.initPdiKitBuilder);